import React from 'react';
import Transition from 'react-transition-group/Transition';
import { DrawerContent } from 'rmwc/Drawer';
import { Icon } from 'rmwc/Icon';
import { Typography } from 'rmwc/Typography';
import { Button } from 'rmwc/Button';
import { Grid, GridCell } from 'rmwc';
import { Text } from '../../components/Text';
import {
  RightDrawer,
  DrawerSubHeader,
  DrawerFooter,
  DrawerFlex,
  DrawerFlexGrow,
} from '../../components/ModuleDrawer/RightDrawer';
import FindIndependentAdvisor from './FindIndependentAdvisor';
import Advisor from './Advisor';

export default ({ history, match, onClose }) => {
  return (
    <DrawerFlexGrow>
      <DrawerContent>
        <div className="hrbr-drawer-content-middle">
          <Text className="text-center" use="subtitle1">
            Get a free 30-minute plan review with a registered investment advisor.
          </Text>

          <Advisor advisor="william" title="Harbor Advisor on Call" hideSchedule />

          <Text className="my-2" use="subtitle1">
            <strong>We're here to help with whatever you need</strong>
          </Text>

          <div className="hrbr-drawer-blockquote">
            <Grid>
              <GridCell span="4">
                <img className="mb-2" src={require('images/icon-questions.png')} width={70} height={70} />
                <Text use="subtitle1">
                  <strong>Your Questions</strong>
                </Text>
                <Text use="body1">Ask questions, and be confident in your plan</Text>
              </GridCell>
              <GridCell span="4">
                <img className="mb-2" src={require('images/icon-situation.png')} width={70} height={70} />
                <Text use="subtitle1">
                  <strong>Your Situation</strong>
                </Text>
                <Text use="body1">Learn how to further personalize your plan</Text>
              </GridCell>
              <GridCell span="4">
                <img className="mb-2" src={require('images/icon-options.png')} width={70} height={70} />
                <Text use="subtitle1">
                  <strong>Your Options</strong>
                </Text>
                <Text use="body1">Get suggestions on what to do next</Text>
              </GridCell>
            </Grid>
          </div>

          <Text use="caption" className="text-left">
            If you still need help after, you can get unlimited access to our advisors with an optional membership
            upgrade. <a href="#">Learn more</a> about upgrading to Planning Complete.
          </Text>

          <div className="text-center m-4">
            <Button onClick={() => history.push(`${match.url}/schedule`)} raised theme="secondary-bg on-secondary">
              Talk to Us
            </Button>

            <Text className="text-center m-3" use="body2">
              Your 30 minute plan review is completely free.
            </Text>
          </div>

          <FindIndependentAdvisor onClick={() => history.push('/dashboard/independent-advisor')} />
        </div>
      </DrawerContent>
      <DrawerFooter>
        <Button onClick={onClose} theme="primary-bg" raised>
          Back
        </Button>
      </DrawerFooter>
    </DrawerFlexGrow>
  );
};
